import { useMutation, useQuery, useQueryClient } from "react-query";

import { emailTemplateQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import useUserContext from "../../contexts/UserContext";
import { IDefaultResponseWithData } from "./../../models/system/DefaultResponse";
import { IEmailTemplate } from "../../models/emailTemplates/EmailTemplate";

export default function useEmailTemplate(emailTemplateId?: string) {
  const staleTime = 10000;
  const queryClient = useQueryClient();
  const {
    user: { agency },
  } = useUserContext();
  const { get, put } = useApiHelper();

  const emailTemplate = useQuery(
    emailTemplateQueryKeys.single(emailTemplateId ?? "-"),
    () =>
      get(
        `/emailtemplate/${emailTemplateId}`
      ) as unknown as IDefaultResponseWithData<IEmailTemplate>,
    {
      staleTime: staleTime,
      enabled: !!emailTemplateId,
    }
  );

  // const update = useMutation(
  //   (body) => put(`/emailtemplate/${emailTemplateId}`, { body: body }),
  //   {
  //     onSuccess: () => {
  //       queryClient.invalidateQueries(["blogPosts", agency.id]);
  //     },
  //   }
  // );

  return {
    emailTemplate,
    // update,
  };
}
